import { BuyerId, JobTitle, PersonSelect, Root, SiteSelect } from './components';

export const BusinessFields = {
  Root,
  SiteSelect,
  JobTitle,
  BuyerId,
  PersonSelect,
};
